export default __webpack_public_path__ + "static/media/marker5.8aa02503.png";